/** @jsx jsx */
import { jsx } from "theme-ui";
import PortableTextComponent from "./portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";

const FormEmbed = ({ value }) => {
  return (
    <div
      id={value?.id?.current ? value?.id?.current : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        paddingTop: "6",
        paddingBottom: "6",
      }}
    >
      <Container>
        <div
          sx={{
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "wrap",
            flexDirection: [
              "column",
              "column",
              value?.form_position == "left" ? "row-reverse" : "row",
            ],
            justifyContent: "space-between",
          }}
          className="form-embed-container"
        >
          <div
            className="form-embed-text"
            sx={{
              color: "textGray",
              fontSize: "body",
              width: ["100%", "100%", "calc(100% - 700px)"],
              "h1,h2,h3,h4,h5,h6": {
                color: "primary",
              },
              h2: {
                fontSize: "3rem",
                lineHeight: "1.2",
                margin: "0 0 20px",
                maxWidth: "555px",
              },
            }}
          >
            {value.headline && <h2>{value.headline}</h2>}
            {value.subhead && <h3>{value.subhead}</h3>}

            <PortableText
              value={value.text}
              components={PortableTextComponent}
            />
          </div>
          {value.embed && (
            <div
            className="form-embed-form"
            sx={{
              paddingLeft: ["0px", "0px", value?.form_position == 'left' ? "0px" : "0px"],
              paddingRight: ["0px", "0px", value?.form_position == 'right' ? "0px" : "0px"],
              marginBottom: ["40px", "40px", "0px"],
              width: ["100%", "100%", "615px"],
              "#mc_embed_signup div#mce-responses":{
                width: "100% !important",
                margin: "0px !important",
                padding: "0px !important",
              },
              "#mce-success-response":{
                all: "unset",
                color:"#14158B !important",
                margin: "1rem 0px 0px 0px !important",
                padding:"0px !important",
                fontWeight:"300 !important",
              },
              "#mc_embed_signup":{
                width:"100%",
                all: "unset",
                "form":{
                  margin:"0px",
                  all: "unset",
                  ".mc-field-group":{
                    all: "unset",
                    'select':{
                      width:"100%",
                      fontWeight:"300",
                      padding:"0px 28px",
                    },
                    'label':{
                      marginTop:"1rem",
                    },
                    'input[type="text"],input[type="email"],textarea':{
                      all: "unset",
                      boxSizing: "border-box",
                      border: "thin solid",
                      borderColor: "primary",
                      borderRadius: "8px",
                      height: "64px",
                      padding: "0px 32px",
                      marginBottom: "0rem",
                      fontSize: "1.2rem",
                      color: "primary",
                      fontFamily: "poppins, sans-serif",
                      width:"100%",
                      backgroundColor:"#ffffff",
                    },
                    '.asterisk':{
                      color:"primary"
                    }
                  }
                }
              },
              'input::placeholder':{
                color:"primary",
              },
              'input[type="text"],input[type="email"],select':{
                  boxSizing: "border-box",
                  border: "thin solid",
                  borderColor: "primary",
                  borderRadius: "8px",
                  height: "64px",
                  padding: "0px 32px",
                  marginBottom: "1rem",
                  fontSize: "1.2rem",
                  color: "primary",
                  fontFamily: "poppins, sans-serif",
                  width:"100%",
                  formWeight:"300",
                  backgroundColor:"#ffffff",
                },
                'textarea':{
                  boxSizing: "border-box",
                  border: "thin solid",
                  borderColor: "primary",
                  borderRadius: "8px",
                  padding: "25px 32px",
                  marginBottom: "1rem",
                  fontSize: "1.2rem",
                  color: "primary",
                  fontFamily: "poppins, sans-serif",
                  fontWeight: "300",
                },
                "#mc_embed_signup .button":{
                  all: "unset",
                  variant: "buttons.primaryBlue",
                  width:"auto",
                  marginTop:"2rem",
                },
                ".button, button":{
                  variant: "buttons.primaryBlue",
                  width:"auto",
                },
                ".indicates-required":{
                  color:"textGray",
                  display:"none",
                } 
            }}
          >
            <div>
              <div
                key={`body`}
                id="___gatsby"
                dangerouslySetInnerHTML={{ __html: value.embed }}
              />
            </div>
          </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default FormEmbed;
